import { Steps } from 'antd'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepsCompleted from 'components/icons/StepsCompleted'
import StepsIcon from 'components/icons/StepsIcon'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
const { Step } = Steps

const Div = styled.div`
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: ${COLORS.GREEN_S_100};
  }
`

const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 50rem !important;
  }
`
export const RoundDiv = styled.p`
  font-weight: ${FONT.FW_500};
  font-size: 15px;
  line-height: 21px;
  color: ${props => props.textcolor};
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`

const AntdStepsWithPanel = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current = '1',
  onChange,
  checkLine = false,
  ...props
}) => {
  const getIcon = (step, current) => {
    if (current > step?.activeKey) {
      return <StepsCompleted />
    } else if (step?.activeKey == current) {
      return <StepsIcon />
    } else {
      return <EmptyCircle />
    }
  }
  return (
    <Div>
      <Steps
        direction={direction}
        size={size}
        current={current}
        {...props}
        onChange={onChange}
      >
        {steps?.map((step, index) => (
          <StyledStep
            key={index + 'stepsWithPanel'}
            icon={getIcon(step, current)}
            description={
              <RoundDiv
                style={{
                  borderBottom: checkLine
                    ? 'none'
                    : `1px solid ${COLORS.GREY_T_90}`,
                  color:
                    step?.activeKey === current
                      ? COLORS.GREY_T_30
                      : COLORS.GREY_T_60,
                }}
              >
                {step?.description}
              </RoundDiv>
            }
            title={<div>{step?.title}</div>}
          />
        ))}
      </Steps>
    </Div>
  )
}

export default AntdStepsWithPanel
